import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function Navbar({ transparent = false, content = {} }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isHome = location.pathname === "/";
  const showBg = !transparent || scrolled || mobileOpen;

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        showBg ? "bg-background/90 backdrop-blur-xl border-b border-border/40 shadow-sm" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid="navbar-logo" className="font-serif text-2xl md:text-3xl tracking-tight text-foreground hover:opacity-80 transition-opacity">
          Imassasje
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-10">
          {isHome && (
            <>
              <a href="#tjenester" data-testid="nav-services" className="text-sm tracking-wide uppercase text-white hover:text-white/80 transition-colors">
                Tjenester
              </a>
              <a href="#om-oss" data-testid="nav-about" className="text-sm tracking-wide uppercase text-white hover:text-white/80 transition-colors">
                Om meg
              </a>
            </>
          )}
          <Link
            to="/bestill"
            data-testid="nav-book-btn"
            className="rounded-full bg-primary text-primary-foreground px-7 py-2.5 text-sm tracking-wide hover:bg-primary/90 transition-all hover:scale-105"
          >
            {content.btn_nav || "Book time"}
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-foreground"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div data-testid="mobile-menu" className="md:hidden bg-background/95 backdrop-blur-xl border-b border-border px-6 py-6 space-y-4 animate-fade-in">
          {isHome && (
            <>
              <a href="#tjenester" onClick={() => setMobileOpen(false)} className="block text-sm tracking-wide uppercase text-white">Tjenester</a>
              <a href="#om-oss" onClick={() => setMobileOpen(false)} className="block text-sm tracking-wide uppercase text-white">Om meg</a>
            </>
          )}
          <Link to="/bestill" onClick={() => setMobileOpen(false)} className="block rounded-full bg-primary text-primary-foreground px-7 py-2.5 text-sm tracking-wide text-center">
            {content.btn_nav || "Book time"}
          </Link>
        </div>
      )}
    </nav>
  );
}
